import { render, staticRenderFns } from "./Select2.vue?vue&type=template&id=36d2b45c&scoped=true&"
import script from "./Select2.vue?vue&type=script&lang=js&"
export * from "./Select2.vue?vue&type=script&lang=js&"
import style0 from "./Select2.vue?vue&type=style&index=0&id=36d2b45c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2b45c",
  null
  
)

export default component.exports